export default __webpack_public_path__ + "images/nr-dcf2ea3a8e5dbf8a9b805ecb2d2fc922.svg";